<template>
    <div class="operate">
        <el-dialog :title="_type == 6 ? '移为白名单' : ''" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div class="content">
                <p v-if="_type < 5">{{ msgList[_type] }}</p>
                <div class="date" v-if="_type == 4">
                    <p>确定对该经销商恢复授权？</p>
                    <div class="itme" v-if="!CheckDateTime(info.end_time)">
                        <span>授权日期：</span>
                        <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="expireTimeOption"
                        >
                        </el-date-picker>
                    </div>
                </div>
                <div class="form" v-if="_type == 5">
                    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                        <el-form-item label="有效时间：" prop="date">
                            <el-date-picker
                                style="width: 100%"
                                v-model="form.date"
                                type="datetimerange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                :picker-options="expireTimeOption"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="销售价：" prop="sale_price">
                            <el-input v-model="form.sale_price" clearable placeholder="请输入销售价"></el-input>
                        </el-form-item>
                        <el-form-item label="上限价：" prop="price_top">
                            <el-input v-model="form.price_top" clearable placeholder="请输入上限价"></el-input>
                        </el-form-item>
                        <el-form-item label="下限价：" prop="price_bottom">
                            <el-input v-model="form.price_bottom" clearable placeholder="请输入下限价"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="handleClose">取 消</el-button>
                <el-button type="primary" size="medium" @click="submit" :loading="btnLoad">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
            /**
             * 弹窗类型：
             * 0.经销商停权
             * 1.经销商取消
             * 2.确认移为普通名单
             * 3.确认移为黑名单
             * 4.经销商恢复授权
             * 5.移为白名单
             */
            msgList: ["确认对该经销商停止授权？", "取消之后，将不能恢复授权", "确认移为普通名单？", "确认移为黑名单？"],
            value: false,
            value1: false,
            textarea: "",
            dialogVisible: false,
            listData: [],
            form: {
                date: [],
                sale_price: "",
                price_top: "",
                price_bottom: "",
            },
            rules: {
                date: [{ required: true, message: "请选择时间", trigger: "change" }],
                sale_price: [{ required: true, message: "请输入销售价", trigger: "blur" }],
                price_top: [{ required: true, message: "请输入上限价", trigger: "blur" }],
                price_bottom: [{ required: true, message: "请输入下限价", trigger: "blur" }],
            },
            date: [],
            info: "",
            btnLoad: false,
        };
    },
    props: {
        _type: {
            type: Number,
            default: 0,
        },
    },
    mounted() {},
    created() {},
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            agencyProductUpdateType: "brand/agencyProductUpdateType",
            stopAuthor: "brand/stopAuthor",
            deAuthorize: "brand/deAuthorize",
            agencyChannel: "brand/agencyChannel",
        }),
        CheckDateTime(str) {
            var timestamp1 = new Date(str).getTime();
            var timestamp2 = new Date().getTime();
            var d = timestamp1 - timestamp2; //d>0 没到时间  d<0时间已经过了
            return d > 0;
        },
        handleClose() {
            this.btnLoad = false;
            this.id = "";
            this.form = {
                date: [],
                sale_price: "",
                price_top: "",
                price_bottom: "",
            };
            this.date = [];
            this.dialogVisible = false;
        },
        // 提交
        submit() {
            this.btnLoad = true;
            let opt = {
                token: this.getToken,
                id: this.info, //产品id
            };
            let url;
            /**
             * 弹窗类型：
             * 0.经销商停权
             * 1.经销商取消
             * 2.确认移为普通名单
             * 3.确认移为黑名单
             * 4.经销商恢复授权
             * 5.移为白名单
             */
            switch (this._type) {
                case 0:
                    opt.port = "merchant";
                    url = this.stopAuthor;
                    break;
                case 1:
                    url = this.agencyChannel;
                    break;
                case 2:
                    opt.type = 1; //类型  1-普通授权 2-白名单 3-黑名单
                    url = this.agencyProductUpdateType;
                    break;
                case 3:
                    opt.type = 3; //类型  1-普通授权 2-白名单 3-黑名单
                    url = this.agencyProductUpdateType;
                    break;
                case 4:
                    if (this.date.length == 0 && !this.CheckDateTime(this.info.end_time)) {
                        this.btnLoad = false;
                        return this.$message.warning("时间不能为空！");
                    } else {
                        opt.start_time = this.date ? this.date[0] : null;
                        opt.end_time = this.date ? this.date[1] : null;
                    }
                    opt.id = this.info.id;
                    opt.port = "merchant";
                    opt.level = this.info.level;
                    url = this.deAuthorize;
                    break;
                case 5:
                    if (!this.form.sale_price && !this.form.price_top && !this.form.price_bottom && !this.form.date) {
                        this.btnLoad = false;
                        return this.$message.warning("请填写内容！");
                    }
                    opt.type = 2; //类型  1-普通授权 2-白名单 3-黑名单
                    opt.white_sale_price = this.form.sale_price; //白名单销售价
                    opt.white_price_top = this.form.price_top; //白名单价格上限
                    opt.white_price_bottom = this.form.price_bottom; //白名单价格下限
                    opt.white_start_time = this.form.date ? this.form.date[0] : null; //白名单有效开始时间
                    opt.white_end_time = this.form.date ? this.form.date[1] : null; //白名单有效结束时间
                    url = this.agencyProductUpdateType;
                    break;
                case 6:
                    i = 0;
                    break;
            }
            // return console.log(opt);
            url(opt).then(({ data }) => {
                this.btnLoad = false;
                // console.log(data);
                if (data.code == 1) {
                    this.$message.success("修改成功！");
                    this.handleClose();
                    if (this._type == 0 || this._type == 1 || this._type == 4) {
                        this.$emit("initList");
                    } else if (this._type == 2 || this._type == 3 || this._type == 5) {
                        this.$emit("init");
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.operate {
    .content {
        padding: 20px 0;
        & > p {
            text-align: center;
            font-size: 16px;
        }
        .date {
            p {
                text-align: center;
            }
        }
        .itme {
            margin-top: 30px;
        }
        max-height: 500px;
        overflow-y: auto;
        &::-webkit-scrollbar-track-piece {
            background: #d3dce6;
        }

        &::-webkit-scrollbar {
            width: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background: #99a9bf;
            border-radius: 20px;
        }
        .form {
            width: 90%;
            margin: 0 auto;
        }
    }
    // ::v-deep .el-form-item__content {
    //     margin-left: 0 !important;
    // }
    .box {
        width: 80%;
        .row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
                font-size: 18px;
                color: #333;
            }
        }
        span {
            font-size: 14px;
            color: #999;
        }
    }
}
</style>